<template lang="">
  <div>
    <b-card no-body>
      <b-card-header>
        <h4 class="mb-0">
          Anfragen
        </h4>
        <b-card-text class="font-medium-5 mb-0">
          <feather-icon
            icon="HelpCircleIcon"
            size="21"
            class="text-muted cursor-pointer"
          />
        </b-card-text>
      </b-card-header>

      <!-- apex chart -->

      <b-row class="text-center mx-0">
        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top border-right d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="primary"
            icon="BoxIcon"
            :statistic="getCountOfAllInquiries()"
            statistic-title="Anzahl"
          />
        </b-col>

        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top border-right d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="danger"
            icon="BoxIcon"
            :statistic="getAcceptedInquiries()"
            statistic-title="Unbewertet"
          />
        </b-col>

        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="danger"
            icon="BoxIcon"
            :statistic="getOpenInquiries()"
            statistic-title="Offen"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BCardTitle,
  BCardHeader,
} from 'bootstrap-vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import businessMetrics from '@/helper/businessMetrics'

export default {
  setup() {
    const {
      getCountOfAllInquiries,
      getAcceptedInquiries,
      getOpenInquiries,
    } = businessMetrics()

    return {
      getCountOfAllInquiries,
      getAcceptedInquiries,
      getOpenInquiries,
    }
  },

  components: {
    StatisticCardVertical,
    BCard,
    BRow,
    BCol,
    BCardText,
    BCardTitle,
    BCardHeader,
  },
}
</script>
<style lang=""></style>
